<template>
  <page-outline :title="$t('Webheader.collections_list_bulk')">
    <template slot="pageContent">
      <b-container fluid>
        <b-row class="mt-3 align-items-center">
          <b-col cols="auto">
            <back-button class="btnFilter_2 mr-2 btn-back" :returnUrl="returnUrl"></back-button>
          </b-col>

          <b-col class="d-flex justify-content-end" cols="auto">
            <b-button class="btnFilter_2 mr-2 w-100" @click="exportCollection">
              <i class="fa-light fa-upload"></i>
              {{ $t('mandate.export') }}
            </b-button>

            <b-button class="btnFilter_2 mr-2 w-100" @click="displayFilter = !displayFilter">
              <i v-if="displayFilter" class="fa-light fa-minus"></i>
              <i v-else class="fa-light fa-plus"></i>
              {{ $t('filter.fltr') }}
            </b-button>

            <b-button class="btnFilter_2 w-100" @click="onRefresh">
              <i class="fa-light fa-rotate-right"></i>
              {{ $t('common.rfrsh') }}
            </b-button>
          </b-col>
        </b-row>
        <hr class="mx-auto" />

        <!-- FILTERS -->
        <b-row v-if="displayFilter" class="min-w-100 justify-content-start align-items-center">
          <b-col cols="3">
            <span class="filter-item-title d-block mb-1">{{ $t('mandate.unique_mandate_rf') }}</span>
            <input v-model.trim="UMR" class="filter-item-content w-100" style="padding:0.13rem" :placeholder="$t('mandate.unique_mandate_rf')" />
          </b-col>

          <b-col cols="3">
            <span class="filter-item-title d-block mb-1">{{ $t('mandate.status_collection') }}</span>
            <select v-model="Status" class="filter-item-content w-100" style="padding:0.35rem">
              <option value="All">──────────</option>
              <option v-for="s in statuses" :key="s.value" :value="s.value">{{ $t(s.label) }}</option>
            </select>
          </b-col>

          <b-col cols="3">
            <div>
              <span class="filter-item-title d-block mb-1">{{ $t('mandate.date_due_start') }}</span>
              <datetime-picker-custom
                format="YYYY-MM-DD"
                periodFull
                id="filter-datebegin"
                class="mr-3"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateBeginFilter}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                style="padding:0.35rem"
                :maxLength="19"
                :placeholderValue="$t('common.datepicker_format_date3')"
                inputIcon="fa-solid fa-calendar"
                :showTime="false"
                v-model="dateBeginFilter"/>
            </div>
          </b-col>

          <b-col cols="3">
            <div>
              <span class="filter-item-title d-block mb-1">{{ $t('mandate.date_due_end') }}</span>
              <datetime-picker-custom
                format="YYYY-MM-DD"
                periodFull
                id="filter-dateend"
                class="mr-3"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateEndFilter}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                style="padding:0.35rem"
                :maxLength="19"
                :placeholderValue="$t('common.datepicker_format_date3')"
                inputIcon="fa-solid fa-calendar"
                :showTime="false"
                v-model="dateEndFilter"/>
            </div>
          </b-col>

          <b-row class="min-w-100 justify-content-end align-items-center">

              <b-col cols="12" class="d-flex justify-content-end mt-3">
                <b-button class="btnFilter_2 mr-2 w-100" @click="clearFilterFields" :disabled="!hasInputFilter">
                  {{ $t('common.rst') }}
                </b-button>
                <b-button class="btnFilter_2 w-100" @click="onRefresh">
                  {{ $t('common.srch') }}
                </b-button>
              </b-col>
          </b-col>
            </b-row>
        </b-row>

        <hr class="mx-auto mb-4" v-if="displayFilter"/>
        <!-- TABLE -->
        <b-row>
          <b-col cols="12" class="mx-auto mb-4">
            <div style="overflow:auto">
              <spinner v-if="activateSpinner"></spinner>
              <b-table v-else-if="listItemsCollection.length > 0"
                hover
                striped
                responsive
                class="table table-striped"
                style="margin-bottom:0"
                :items="listItemsCollection"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable"
                :key="refreshKey"
                :empty-text="$t('common.security.no_result')"
                @row-clicked="onRowClicked">
                <template #cell(Amount)="data">
                  {{ formatCurrency(data.value) }}
                </template>
                <template #cell(DueDate)="data">
                  {{ data.value }}
                </template>
                <template #cell(SettlementDate)="data">
                  <span v-if="data.value !== ''"> {{ data.value }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(DebitDate)="data">
                  <span v-if="data.value !== ''"> {{ data.value }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(Status)="data">
                  <span v-if="data.value !== ''" :class="['chip','chip--' + statusVariant(data)]">{{ $t('mandate.status_collection_' + data.value) }}</span>
                  <span v-else>-</span>
                </template>
                <template #cell(actions)="{ item }">
                  <b-link @click.stop.prevent="onRowClicked(item)" class="text-decoration-none">
                    {{ $t('mandate.view_details') }}
                  </b-link>
                </template>
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-5">
          <b-col>
            <cm-pagination
              :maxResultsByPage="paginationObject.maxResults"
              :firstIndex="paginationObject.firstIndex"
              :nbResultsTotal="paginationObject.nbResultsTotal"
              :refreshEvent="paginationObject.refresh">
            </cm-pagination>
          </b-col>
        </b-row>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import Spinner from "@/components/common/spinner.vue"
import Pagination from '@/components/common/pagination.vue'
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import moment from 'moment-timezone'
import BackButton from '@/components/common/backButton.vue'


export default {
  name: 'MandateTransactionsUnit',
  components: {
    BackButton,
    'page-outline': PageOutline,
    'datetime-picker-custom': dateTimePicker,
    spinner: Spinner,
    'cm-pagination': Pagination,
  },
  data () {
    return {
      activateSpinner: false,
      CollectionListExport: {},
      dateBeginFilter: null,
      dateEndFilter: null,
      displayFilter: true,
      fields: [
        { key: 'UMR', label: this.$t('mandate.unique_mandate_rf'), sortable: true, class: 'text-center' },
        { key: 'Amount', label: this.$t('mandate.amt'), sortable: true, class: 'text-center' },
        { key: 'DueDate', label: this.$t('mandate.date_due'), sortable: true, class: 'text-center' },
        { key: 'SettlementDate', label: this.$t('mandate.date_settlement'), sortable: true, class: 'text-center' },
        { key: 'DebitDate', label: this.$t('mandate.date_debit'), sortable: true, class: 'text-center' },
        //{ key: 'txDate', label: 'Transaction Date', sortable: true, class: 'text-center' },
        { key: 'Status', label: this.$t('mandate.status_collection'), sortable: true, class: 'text-center status-col' },
        { key: 'actions', label: this.$t('mandate.actions'), class: 'text-center' }
      ],
      filterConditions: {},
      listItemsCollection: [],
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false,
      Status: 'All',
      statuses: [
        { value: 1, label: 'mandate.status_collection_1' },
        { value: 2, label: 'mandate.status_collection_2' },
        { value: 3, label: 'mandate.status_collection_3' },
        { value: 4, label: 'mandate.status_collection_4' },
        { value: 5, label: 'mandate.status_collection_5' },
        { value: 6, label: 'mandate.status_collection_6' },
        { value: 7, label: 'mandate.status_collection_7' },
        { value: 8, label: 'mandate.status_collection_8' },
        { value: 9, label: 'mandate.status_collection_9' },
        { value: 10, label: 'mandate.status_collection_10' },
      ],
      timezone: '+00:00',
      UMR: ""
    }
  },
  created() {
    this.returnUrl = '/mandatetransactions/bulk'
    this.timezone = moment.tz.guess()
    this.IdCollectionBulk = this.$route.query.IdCollectionBulk

    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    // this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getCollection(index)
      that.pageCounter = 0
    })

    this.pageCounter = 0
    this.onRefresh()
  },
  computed: {
    hasInputFilter () {
      return !!this.UMR || this.Status !== 'All' || this.dateBeginFilter || this.dateEndFilter
    }
  },
  methods: {
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getCollection()
    },
    clearFilterFields () {
      this.UMR = ''
      this.Status = 'All'
      this.dateBeginFilter = null
      this.dateEndFilter = null
    },
    convertToISOStringFormat(dateTimeStr) {
      if (!dateTimeStr) return ''
      return dateTimeStr.replace(' ', 'T')
    },
    exportCollection () {
      let that = this
      const statusValue = this.Status === 'All' ? '' : this.Status || ''
      let params = {
        UMR: this.UMR || '',
        Status: statusValue,
        StartDueDate: this.dateBeginFilter,
        EndDueDate: this.dateEndFilter,
        IdCollectionBulk: this.IdCollectionBulk || ''
      }
      this.$engine.Collection.getCollection(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.Collection.length

        this.CollectionListExport = resp.data.Collection

        this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
        let firstLine = this.$t('mandate.unique_mandate_rf') + ';' +
          this.$t('mandate.mandate_type') + ';' +
          this.$t('mandate.sign_mandate_date') + ';' +
          this.$t('mandate.schema_code') + ';' +
          this.$t('mandate.collection_type') + ';' +
          this.$t('mandate.amt') + ';' +
          this.$t('mandate.status_collection') + ';' +
          this.$t('mandate.purpose') + ';' +
          this.$t('mandate.purpose_category') + ';' +
          this.$t('mandate.remittance_info') + ';' +
          this.$t('mandate.cdtr_ref') + ';' +
          this.$t('mandate.direction_collection') + ';' +
          this.$t('mandate.date_due') + ';' +
          this.$t('mandate.date_settlement') + ';' +
          this.$t('mandate.date_debit') + ';' +
          this.$t('mandate.rsn_mandate_amendment') + ';' +
          this.$t('mandate.reject_reason') + ';' +
          this.$t('mandate.reject_code') + ';' +
          this.$t('mandate.dbtr_name_1') + ';' +
          this.$t('mandate.dbtr_iban_1') + ';' +
          this.$t('mandate.dbtr_pspbic_1') + ';' +
          this.$t('mandate.end_to_end_id') + '\r\n'
        let lines = ''
        for (var i = 0; i < this.CollectionListExport.length; i++) {
          let result = this.CollectionListExport[i]
          let statusCollection = this.statuses.find(
            status => status.value === Number(result.Status)
          )?.label

          statusCollection = this.$t(statusCollection)
          lines += result.UMR + ';' +
                   this.$t('mandate.mandate_type_' + result.TypeMandate) + ';' +
                   result.SigningMdDate + ';' +
                   result.SchemaCode + ';' +
                   this.$t('mandate.collection_type_' + result.TypeTransaction) + ';' +
                   result.Amount + ';' +
                   statusCollection  + ';' +
                   result.Purpose + ';' +
                   result.PurposeCategory + ';' +
                   result.RemittanceInfo + ';' +
                   result.CdtrRefCollection + ';' +
                   this.$t('mandate.direction_collection_' + result.Direction) + ';' +
                   result.DueDate + ';' +
                   result.SettlementDate + ';' +
                   result.DebitDate + ';' +
                   result.ReasonMandate + ';' +
                   result.RejectionReason + ';' +
                   result.RejectionCode + ';' +
                   result.DbtrName + ';' +
                   result.DbtrIBAN + ';' +
                   result.DbtrPSPBIC + ';' +
                   result.EndToEndId + '\r\n'
        }
        let data = firstLine + lines
        this.$f7.hidePreloader()
        let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let downloadLink = document.createElement('a')
        let today = moment()
        let fileName = this.$t('Webheader.collections_list') + '_' + today.unix() + '.csv'
        if (
        this.$f7.device.os === 'android' ||
        this.$f7.device.os === 'ios'
        ) {
          downloadFileWithDefinedHeaders(this, fileName, linkSource)
        } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
        }
        this.$f7.alert('', this.$i18n.t('common.exprt_succ'))

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    formatCurrency (n) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'EUR', maximumFractionDigits: 2 }).format(n)
    },
    formatDate(dateIso) {
      return dateIso.replace("T", " ")
    },
    getCollection(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      const statusValue = this.Status === 'All' ? '' : this.Status || ''
      let params = {
        UMR: this.UMR || '',
        Status: statusValue,
        StartDueDate: this.convertToISOStringFormat(this.dateBeginFilter),
        EndDueDate: this.convertToISOStringFormat(this.dateEndFilter),
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        IdCollectionBulk: this.IdCollectionBulk || ''
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.Collection.getCollection(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        that.paginationObject.nbResults = resp.data.Collection.length

        let CollectionList = {}

        CollectionList = resp.data.Collection

        that.updateCollection(CollectionList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getCollection()
    },
    onRowClicked(item) {
      if (item && item.IdCollection) {
        loadPage(this, { url: '/mandatetransactionsunit/details/' + item.IdCollection + '?IdCollectionBulk=' + this.IdCollectionBulk })
      }
    },
    refreshList () {
      this.page = 1
      this.transactions = this.transactions.slice() // re-render
      this.applyFilter()
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'UMR',
        'Amount',
        'DueDate',
        'SettlementDate',
        'DebitDate',
        'Status'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    statusVariant(status) {
      const map = {
        1: 'warning',
        2: 'success',
        3: 'danger',
        4: 'secondary',
        5: 'info',
        6: 'danger',
        7: 'success',
        8: 'warning',
        9: 'secondary',
        10: 'info'
      }
      return map[status.value] || 'secondary'
    },
    updateCollection(CollectionList) {
      this.listItemsCollection = CollectionList
    }
  }
}
</script>

<style scoped>
.status-col { width: 180px; }
.chip{
  --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151;
  display:inline-flex; align-items:center; justify-content:center;
  height:28px; min-width:150px; padding:0 .75rem; border-radius:999px;
  font-size:.75rem; font-weight:600; letter-spacing:.2px;
  border:1px solid var(--chip-border); background-color:var(--chip-bg); color:var(--chip-fg); white-space:nowrap;
}
.chip--success{ --chip-border:#16a34a; --chip-bg:rgba(22,163,74,.10); --chip-fg:#166534; }
.chip--warning{ --chip-border:#f59e0b; --chip-bg:rgba(245,158,11,.12); --chip-fg:#92400e; }
.chip--danger{  --chip-border:#ef4444; --chip-bg:rgba(239,68,68,.10); --chip-fg:#991b1b; }
.chip--secondary{ --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151; }
.chip--info{ --chip-border:#60a5fa; --chip-bg:rgba(96,165,250,.12); --chip-fg:#0b4a6f; }
</style>
